module.exports = __webpack_public_path__ + "static/media/blockImg.c586aa04.jpg";